import { render, staticRenderFns } from "./TasksTableHeader.vue?vue&type=template&id=623939d8&"
import script from "./TasksTableHeader.vue?vue&type=script&lang=ts&"
export * from "./TasksTableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TasksTableHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports